import { SearchParameters } from 'algoliasearch-helper';
import Immutable from 'immutable';
import algoliaFacets from "../config/algolia-facets";
import { getFilters } from "../config/filters";
import { DISJUNCTIVE_FACET_TYPE } from "../records/FacetType";
import { defaults } from "../records/Hit";
const resolvePartition = (facets, basePartition) => facets.reduce(({
  disjunctive,
  conjunctive
}, f) => {
  if (f.get('queryType') === DISJUNCTIVE_FACET_TYPE) {
    return {
      disjunctive: disjunctive.add(f.get('algoliaFacetKey')),
      conjunctive
    };
  } else {
    return {
      disjunctive,
      conjunctive: conjunctive.add(f.get('algoliaFacetKey'))
    };
  }
}, basePartition);
const {
  disjunctive,
  conjunctive
} = getFilters().toSet().filter(f => !f.get('nonRetrievableAttribute')).reduce((filterAccumulator, f) => {
  if (f.get('algoliaFacetKey')) {
    if (f.get('queryType') === DISJUNCTIVE_FACET_TYPE) {
      return {
        disjunctive: filterAccumulator.disjunctive.add(f.get('algoliaFacetKey')),
        conjunctive: filterAccumulator.conjunctive
      };
    } else {
      return {
        disjunctive: filterAccumulator.disjunctive,
        conjunctive: filterAccumulator.conjunctive.add(f.get('algoliaFacetKey'))
      };
    }
  } else if (f.get('custom')) {
    return f.get('customFilters').toSet().reduce((customFilterAccumulator, cf) => {
      if (cf.get('queryType') === DISJUNCTIVE_FACET_TYPE) {
        return {
          disjunctive: customFilterAccumulator.disjunctive.add(cf.get('algoliaFacetKey')),
          conjunctive: customFilterAccumulator.conjunctive
        };
      } else {
        return {
          disjunctive: customFilterAccumulator.disjunctive,
          conjunctive: customFilterAccumulator.conjunctive.add(cf.get('algoliaFacetKey'))
        };
      }
    }, {
      disjunctive: filterAccumulator.disjunctive,
      conjunctive: filterAccumulator.disjunctive
    });
  }
  return {
    disjunctive: filterAccumulator.disjunctive,
    conjunctive: filterAccumulator.conjunctive
  };
}, {
  disjunctive: Immutable.Set(),
  conjunctive: Immutable.Set()
});
const combinedAlreadyResolved = new Set(disjunctive.concat(conjunctive));
const intermediatePartition = resolvePartition(algoliaFacets.toSet().filter(af => !combinedAlreadyResolved.has(af.get('algoliaFacetKey'))), {
  disjunctive,
  conjunctive
});
export default (({
  additionalFacets
}) => {
  const finalPartition = resolvePartition(additionalFacets, intermediatePartition);
  return new SearchParameters({
    attributesToRetrieve: Object.keys(defaults),
    disjunctiveFacets: finalPartition.disjunctive.toJS(),
    facets: finalPartition.conjunctive.toJS()
  }).addDisjunctiveFacetRefinement(algoliaFacets.getIn(['hidden', 'algoliaFacetKey']), 'notHidden');
});